(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.MDCCartSavingsModel = factory();
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function integer(value) { return Number.isSafeInteger(value) && value >= 0; }

  function calculate(cart, config) {
    config = config || {};
    var issues = [];
    var items = cart && cart.items;
    var excludedProducts = Array.isArray(config.excludedSavingsProductIds) ? config.excludedSavingsProductIds : [];
    function isExcluded(item) { return excludedProducts.some(function (id) { return String(id) === String(item.product_id); }); }
    function invalid(reason) {
      return { valid: false, complete: false, total: null, issues: [reason || 'invalid_cart'] };
    }
    if (!Array.isArray(items) || !integer(cart.original_total_price) || !integer(cart.total_price) ||
        !integer(cart.items_subtotal_price) || typeof cart.currency !== 'string' ||
        !/^[A-Z]{3}$/.test(cart.currency)) return invalid();

    var keys = new Set();
    var original = 0;
    var final = 0;
    var allMarkdowns = 0;
    for (var item of items) {
      if (!item || !integer(item.quantity) || item.quantity < 1 || !integer(item.original_price) ||
          !integer(item.original_line_price) || !integer(item.final_line_price) ||
          item.original_line_price !== item.original_price * item.quantity ||
          item.final_line_price > item.original_line_price || !item.key || keys.has(item.key) ||
          (item.compare_at_price != null && !integer(item.compare_at_price))) return invalid();
      keys.add(item.key);
      original += item.original_line_price;
      final += item.final_line_price;
      if (!isExcluded(item)) allMarkdowns += Math.max((item.compare_at_price || 0) - item.original_price, 0) * item.quantity;
    }
    if (!integer(original) || !integer(final) || !integer(allMarkdowns) ||
        original !== cart.original_total_price || final !== cart.items_subtotal_price ||
        cart.total_price > final) return invalid();

    var shopifyDiscounts = original - cart.total_price;
    if (cart.total_discount != null) {
      if (!integer(cart.total_discount) || cart.total_discount !== shopifyDiscounts) {
        return invalid('inconsistent_total_discount');
      }
      shopifyDiscounts = cart.total_discount;
    }
    var applications = cart.cart_level_discount_applications || [];
    if (!Array.isArray(applications)) return invalid();
    var gifts = Array.isArray(config.gifts) ? config.gifts : [];
    var giftDiscountExcluded = 0;
    var giftMarkdowns = 0;
    var giftQuantity = 0;
    var details = [];
    var codes = new Map();
    var excludedDiscounts = 0;
    var excludedCartDiscounts = 0;
    var excludedCodes = new Map();

    function codeIdentity(application) {
      return application && application.type === 'discount_code' &&
        typeof application.title === 'string' && application.title.trim() ? application.title.trim().toUpperCase() : null;
    }

    function addCode(application, amount) {
      if (!application || application.type !== 'discount_code' ||
          typeof application.title !== 'string' || !application.title.trim() || amount === 0) return;
      var code = application.title.trim();
      var identity = code.toUpperCase();
      var existing = codes.get(identity);
      if (existing) existing.amount += amount;
      else codes.set(identity, { code: code, amount: amount });
    }

    for (var line of items) {
      var lineDiscount = line.original_line_price - line.final_line_price;
      var allocations = line.line_level_discount_allocations || [];
      if (!Array.isArray(allocations)) return invalid();
      var allocated = 0;
      for (var allocation of allocations) {
        if (!allocation || !integer(allocation.amount)) return invalid();
        allocated += allocation.amount;
      }
      if (!integer(allocated) || allocated > lineDiscount) return invalid('inconsistent_line_discounts:' + line.key);
      if (allocated < lineDiscount) issues.push('unclassified_line_discount:' + line.key);

      if (isExcluded(line)) {
        var completeAllocations = line.discount_allocations;
        var completeAmount = 0;
        if (!Array.isArray(completeAllocations)) {
          if (final > cart.total_price) return invalid('missing_excluded_allocations:' + line.key);
          completeAllocations = allocations;
          completeAmount = lineDiscount - allocated;
        }
        for (var serviceAllocation of completeAllocations) {
          if (!serviceAllocation || !integer(serviceAllocation.amount)) return invalid('invalid_excluded_allocations:' + line.key);
          completeAmount += serviceAllocation.amount;
          var serviceCode = codeIdentity(serviceAllocation.discount_application);
          if (serviceCode) excludedCodes.set(serviceCode, (excludedCodes.get(serviceCode) || 0) + serviceAllocation.amount);
        }
        if (!integer(completeAmount) || completeAmount < lineDiscount || completeAmount > line.original_line_price) {
          return invalid('inconsistent_excluded_allocations:' + line.key);
        }
        excludedDiscounts += completeAmount;
        excludedCartDiscounts += completeAmount - lineDiscount;
      }

      var tier = line.properties && line.properties.__essential_cart_drawer_reward_tier_id;
      var rule = gifts.find(function (gift) {
        return gift && gift.rulesVerified === true && gift.tierId && tier === gift.tierId &&
          String(gift.variantId) === String(line.variant_id);
      });
      var giftAllocation = 0;
      if (rule) {
        for (var candidate of allocations) {
          var application = candidate.discount_application;
          if (application && (application.title === rule.discountTitle ||
              (Array.isArray(rule.additionalDiscountTitles) && rule.additionalDiscountTitles.includes(application.title))) &&
              (application.type === 'automatic' ||
               (application.type === '' && rule.automaticTitleVerified === true))) {
            giftAllocation += candidate.amount;
          }
        }
      }
      var freeQuantity = 0;
      if (giftAllocation > 0 && line.original_price > 0 &&
          giftAllocation % line.original_price === 0 && giftAllocation <= lineDiscount) {
        freeQuantity = giftAllocation / line.original_price;
        giftDiscountExcluded += giftAllocation;
        giftQuantity += freeQuantity;
        giftMarkdowns += Math.max((line.compare_at_price || 0) - line.original_price, 0) * freeQuantity;
      } else {
        if (tier || giftAllocation > 0) issues.push('unconfirmed_reward:' + line.key);
        giftAllocation = 0;
      }

      for (var discount of allocations) addCode(discount.discount_application, discount.amount);
      details.push({
        key: line.key, quantity: line.quantity, freeQuantity: freeQuantity, giftAllocation: giftAllocation
      });
    }

    var cartAllocated = 0;
    for (var cartApplication of applications) {
      if (!cartApplication || !integer(cartApplication.total_allocated_amount)) return invalid();
      if (cartApplication.target_type === 'shipping_line') continue;
      cartAllocated += cartApplication.total_allocated_amount;
      addCode(cartApplication, cartApplication.total_allocated_amount);
    }
    var cartDiscount = final - cart.total_price;
    if (!integer(cartAllocated) || cartAllocated > cartDiscount) return invalid('inconsistent_cart_discounts');
    if (cartAllocated < cartDiscount) issues.push('unclassified_cart_discount');
    if (!integer(excludedDiscounts) || excludedDiscounts > shopifyDiscounts ||
        !integer(excludedCartDiscounts) || excludedCartDiscounts > cartDiscount) return invalid('inconsistent_excluded_discounts');
    var cartCodeSavings = Array.from(codes.values()).map(function (code) {
      return { code: code.code, amount: code.amount };
    });
    for (var excludedCode of excludedCodes) {
      var includedCode = codes.get(excludedCode[0]);
      if (excludedCode[1] > 0 && (!includedCode || includedCode.amount < excludedCode[1])) return invalid('inconsistent_excluded_codes');
      if (includedCode) {
        includedCode.amount -= excludedCode[1];
        if (includedCode.amount === 0) codes.delete(excludedCode[0]);
      }
    }

    var codeSavings = Array.from(codes.values());
    var promoSavings = codeSavings.reduce(function (sum, code) { return sum + code.amount; }, 0);
    var referenceSavings = allMarkdowns - giftMarkdowns;
    var giftValue = giftDiscountExcluded + giftMarkdowns;
    var productDiscounts = shopifyDiscounts - giftDiscountExcluded - excludedDiscounts;
    var otherDiscounts = productDiscounts - promoSavings;
    var total = allMarkdowns + shopifyDiscounts - excludedDiscounts;
    var cartTotal = total + excludedDiscounts;
    if (!integer(referenceSavings) || !integer(giftValue) || !integer(productDiscounts) ||
        !integer(promoSavings) || !integer(otherDiscounts) || !integer(total) || !integer(cartTotal) ||
        referenceSavings + giftValue + promoSavings + otherDiscounts !== total) return invalid();

    return {
      valid: true, complete: true, currency: cart.currency,
      productDiscounts: productDiscounts, referenceSavings: referenceSavings,
      productMarkdowns: referenceSavings, productSavings: productDiscounts + referenceSavings,
      giftDiscountExcluded: giftDiscountExcluded, giftValue: giftValue, giftQuantity: giftQuantity,
      promoSavings: promoSavings, codeSavings: codeSavings, otherDiscounts: otherDiscounts,
      cartCodeSavings: cartCodeSavings, cartTotal: cartTotal,
      shopifyDiscounts: shopifyDiscounts, excludedDiscounts: excludedDiscounts, total: total, issues: issues, lines: details
    };
  }

  function latestOnly(onValue, onPending, onError) {
    var generation = 0;
    var pending = typeof onPending === 'function' ? onPending : function () {};
    var failed = typeof onError === 'function' ? onError : function () {};
    var run = async function (read) {
      var current = ++generation;
      pending();
      try {
        var value = await read();
        if (current === generation) onValue(value);
      } catch (error) {
        if (current === generation) failed(error);
      }
    };
    run.invalidate = function () { ++generation; pending(); };
    return run;
  }

  function protectionRemovalUpdates(cart) {
    if (!Array.isArray(cart?.items)) return null;
    var items = cart.items;
    var keys = new Set();
    for (var item of items) {
      if (!item || !item.key || keys.has(item.key) || !integer(item.quantity) ||
          item.quantity < 1 || typeof item.protection_eligible !== 'boolean') return null;
      keys.add(item.key);
    }
    if (!items.some(function (item) { return String(item.product_id) === '12602893959486'; }) ||
        items.some(function (item) { return item.protection_eligible; })) return null;
    return Object.fromEntries(items.filter(function (item) {
      return String(item.product_id) === '12602893959486' || Boolean(item.properties?.__essential_cart_drawer_reward_tier_id);
    }).map(function (item) { return [item.key, 0]; }));
  }

  return { calculate: calculate, latestOnly: latestOnly, protectionRemovalUpdates: protectionRemovalUpdates };
}));
